// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__3NAoT","primary":"Button_primary__3TIE1","info":"Button_info__3xfFj","outline":"Button_outline__1I8GK"};